import Model from '@/core/models/Model';

export default class SupportRequirement extends Model {
  resource() {
    return 'support-requirements?only_selected=true';
  }
}
